import { Stack } from "@dropbox/dig-foundations";
import { UserProfileCard } from "@mirage/mosaics/BaseProfilePage/UserProfileCard";
import {
  CollapsibleSection,
  CollapsibleSectionTitle,
} from "@mirage/mosaics/UserProfilePage/CollapsibleSection";
import type { BasicUserInfo } from "@mirage/mosaics/UserProfilePage/types";
import { useEffect, useState } from "react";

import styles from "./ProfileEmployees.module.css";

interface ProfileEmployeesProps {
  pageUuid: string;
  sectionTitle: string;
  employees: BasicUserInfo[];
  peopleType:
    | "peers"
    | "reports"
    | "new_arrivals"
    | "work_anniversaries"
    | "birthdays";
  emptyContent?: React.ReactNode;
  alwaysShowAll: boolean;
}

const MAX_EMPLOYEES_FOR_LIMITED_DISPLAY = 9;

export const ProfileEmployees = ({
  pageUuid,
  sectionTitle,
  employees,
  peopleType,
  emptyContent,
  alwaysShowAll,
}: ProfileEmployeesProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, [pageUuid]);

  if (employees.length === 0 && emptyContent === undefined) return null;

  const truncatable =
    !alwaysShowAll && employees.length > MAX_EMPLOYEES_FOR_LIMITED_DISPLAY;
  const employeesToShow =
    truncatable && !showAll
      ? employees.slice(0, MAX_EMPLOYEES_FOR_LIMITED_DISPLAY)
      : employees;

  return (
    <Stack>
      <CollapsibleSectionTitle
        sectionTitle={sectionTitle}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        showAll={truncatable ? showAll : undefined}
        setShowAll={truncatable ? setShowAll : undefined}
      />
      <CollapsibleSection isOpen={isOpen}>
        {employees.length ? (
          <div className={styles.profileReportsList}>
            {employeesToShow.map((person) => {
              return (
                <UserProfileCard
                  key={`user-profile-page-person__${person.account_id}`}
                  user={person}
                  peopleType={peopleType}
                  featureLine="people"
                />
              );
            })}
          </div>
        ) : (
          emptyContent
        )}
      </CollapsibleSection>
    </Stack>
  );
};
